import "./ServiceCalendar.scss";
import EventCalendar from "../../component/shared/EventCalender/components/EventCalendar/EventCalendar";

function ServiceCalendar({ data, currentDate, setCurrentDate, currentMonth, setCurrentMonth, currentYear, setCurrentYear, colors }) {

  return (
    <div
      style={{
        width: "100%",
        //minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        //margin: '3em 0'
      }}
    >
      <EventCalendar
        dataSource={data}
        pallet={{ primary: "#000000", secondary: "#00008B" }}
        onDataChange={(newEvents) => setDataSource(newEvents)}
        currentDate={currentDate}
        setCurrentDate={setCurrentDate}
        currentMonth={currentMonth}
        setCurrentMonth={setCurrentMonth}
        currentYear={currentYear}
        setCurrentYear={setCurrentYear}
        colors={colors}
      />
    </div>
  );
}

export default ServiceCalendar;